import { generateRequestId } from '@support/core';

/**
 * Identifies **this tab**, for the lifetime of this page load.
 *
 * Every GraphQL operation carries it (see `apolloOriginIdLink`), and every
 * live-update event echoes it back, so a tab can tell the changes it made itself
 * from the changes that reached it from somewhere else — including the user's own
 * other tabs, their phone, and MCP acting under their token.
 *
 * Module scope, deliberately not persisted: two tabs must never share one, and a
 * reload starts a genuinely new client whose optimistic state is empty. Never
 * treat it as identity — it is client-supplied, and a consumer only ever
 * suppresses an event when the server-derived `actorId` agrees (see
 * `useLiveUpdates`).
 */
/*
 * `generateRequestId()` yields `hcreq:` + 11 alphanumerics. The API validates
 * the header against `ORIGIN_ID_PATTERN` (`[A-Za-z0-9:_-]`, max 64) and drops
 * anything else — swapping this for a generator with a wider alphabet would
 * silently stop the server stamping origins, and every tab would start
 * reloading on its own writes.
 */
export const CLIENT_ORIGIN_ID = generateRequestId();

/** Header the API reads it from — mirrors `ORIGIN_ID_HEADER` on the server. */
export const ORIGIN_ID_HEADER = 'x-support-origin-id';
